import api from './axiosConfig';

// Fetch loan eligibility
export const fetchLoanEligibility = async () => {
    try {
        const response = await api.get('/loans/eligibility');
        return response.data;
    } catch (error) {
        console.error('Error fetching loan eligibility:', error);
        throw error;
    }
};

// Fetch user's loans
export const fetchMyLoans = async () => {
    try {
        const response = await api.get('/loans/my-loans');
        return response.data;
    } catch (error) {
        console.error('Error fetching my loans:', error);
        throw error;
    }
};

// Apply for a loan
export const applyForLoan = async (loanData) => {
    try {
        const response = await api.post('/loans/apply', loanData);
        return response.data;
    } catch (error) {
        console.error('Error applying for loan:', error);
        throw error;
    }
};

// Repay loan
export const repayLoan = async (loanId, amount, phone_number) => {
    try {
        const response = await api.post(`/loans/${loanId}/repay`, { amount, phone_number });
        return response.data;
    } catch (error) {
        console.error('Error repaying loan:', error);
        throw error;
    }
};
